"use client";
import { useSelector } from "react-redux";

export const useAuthState = () => {
	const { user, credentials } = useSelector((state: any) => state.auth);

	return {
		user,
		credentials,
	};
};
